export default {
  deleteButtonText: 'Supprimer',
  modalDeleteText: 'Êtes-vous sûr de vouloir supprimer le message ?',
  modalMultipleDeleteText: 'Voulez-vous supprimer définitivement les messages sélectionnés ?',
  modalDeleteConfirmButtonText: 'Supprimer',
};
